webpackJsonp([0,1],[
/* 0 */,
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/scene__clouds-1.e5f5731.svg";

/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Clouds = undefined;
	
	var _slicedToArray2 = __webpack_require__(101);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _LoopElement = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cloud(selector, duration) {
	  this.selector = selector;
	  this.duration = duration;
	  this.tween = new _LoopElement.LoopElement(this.selector, this.duration);
	}
	
	var Clouds = function () {
	  function Clouds(clouds) {
	    (0, _classCallCheck3.default)(this, Clouds);
	
	    this.clouds = clouds;
	    this.loopElements = [];
	  }
	
	  (0, _createClass3.default)(Clouds, [{
	    key: 'setUpTweens',
	    value: function setUpTweens() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.clouds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	              selector = _step$value[0],
	              duration = _step$value[1];
	
	          this.loopElements.push(new Cloud(selector, duration));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'animate',
	    value: function animate(page) {
	      this.setUpTweens();
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.loopElements), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var cloud = _step2.value;
	
	          cloud.tween.animate(page);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.loopElements), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var cloud = _step3.value;
	
	          cloud.tween.delete();
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this.loopElements = [];
	    }
	  }]);
	  return Clouds;
	}();
	
	exports.Clouds = Clouds;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ParallaxClass = undefined;
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(81);
	
	var ParallaxClass = function () {
	  function ParallaxClass() {
	    (0, _classCallCheck3.default)(this, ParallaxClass);
	
	    this.options = {
	      calibrateX: true,
	      calibrateY: true,
	      invertX: false,
	      invertY: true,
	      limitX: false,
	      limitY: 0,
	      scalarX: 2,
	      scalarY: 8,
	      frictionX: 0.2,
	      frictionY: 0.8
	    };
	  }
	
	  (0, _createClass3.default)(ParallaxClass, [{
	    key: 'addToPage',
	    value: function addToPage(page) {
	      if (this.parallax !== undefined) {
	        this.parallax.enable();
	      } else {
	        var _parent = document.getElementById(page);
	        var _scene = _parent.getElementsByClassName('scene')[0];
	
	        var _parallax = new window.Parallax(_scene, this.options);
	
	        this.parallax = _parallax;
	        this.parallax.enable();
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      if (this.parallax !== undefined) {
	        this.parallax.disable();
	      }
	    }
	  }]);
	  return ParallaxClass;
	}();
	
	exports.ParallaxClass = ParallaxClass;

/***/ },
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Modals = undefined;
	
	var _promise = __webpack_require__(45);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _modalData = __webpack_require__(85);
	
	var _modalData2 = _interopRequireDefault(_modalData);
	
	var _scoreData = __webpack_require__(44);
	
	var _scoreData2 = _interopRequireDefault(_scoreData);
	
	var _Scores = __webpack_require__(19);
	
	var _gsap = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modals = function () {
	  function Modals() {
	    (0, _classCallCheck3.default)(this, Modals);
	
	    this.scores = new _Scores.Scores();
	
	    this.modalData = _modalData2.default;
	    this.scoreData = _scoreData2.default;
	    this.modalController = document.querySelector('.modal-controls');
	    this.modalContainer = document.querySelector('.modal-container');
	    this.modalContainerWrap = document.querySelector('.modal-container__wrap');
	    this.modalMask = document.querySelector('.modal-mask');
	
	    this.buttons = [];
	
	    this.animationSpeed = 0.15;
	    this.animationEasing = _gsap.Linear.easeNone;
	    this.animationScale = { min: 0.8, max: 1 };
	  }
	
	  (0, _createClass3.default)(Modals, [{
	    key: 'addToPage',
	    value: function addToPage(page) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	
	      var _buttonFragment = document.createDocumentFragment();
	
	      if (this.modalData[page]) {
	        this.buttons = [];
	
	        var i = 1;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.modalData[page]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var a = _step.value;
	
	            var _button = document.createElement('a');
	            _button.classList.add('modal__button');
	            _button.classList.add('modal__button--' + a.type);
	            _button.classList.add('modal__button--' + a.modal);
	            _button.dataset.num = i + '';
	            _button.style.left = a.x;
	            _button.style.top = a.y;
	
	            if (this.scores.getAnswer(page, a.modal)) {
	              if (this.scores.checkAnswer(page, a.modal)) {
	                _button.classList.add('modal__button--correct');
	                _button.classList.remove('modal__button--wrong');
	              } else {
	                _button.classList.remove('modal__button--correct');
	                _button.classList.add('modal__button--wrong');
	              }
	            }
	
	            this.buttons.push(_button);
	
	            _buttonFragment.appendChild(_button);
	
	            this.bindButtonEvents(_button, a.modal, page, a.type);
	            i++;
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.modalController.appendChild(_buttonFragment);
	        this.showButtons(delay);
	      } else {
	        console.log('The page passed doesn\'t have any modals defined');
	      }
	    }
	  }, {
	    key: 'bindButtonEvents',
	    value: function bindButtonEvents(button, modal, page, type) {
	      var _this = this;
	
	      button.addEventListener('click', function (e) {
	        e.preventDefault();
	
	        var getContent = new _promise2.default(function (resolve, reject) {
	          var uri = '/static/modals/' + page + '/' + modal + '.html';
	          var request = new XMLHttpRequest();
	
	          request.open('GET', uri, true);
	          request.onload = function () {
	            if (request.status >= 200 && request.status < 400) {
	              resolve(request.response);
	            } else {
	              reject(request.statusText);
	            }
	          };
	          request.send();
	        });
	
	        getContent.then(function (content) {
	          var _modalFragment = document.createDocumentFragment();
	
	          var _modalClose = document.createElement('a');
	          _modalClose.classList.add('modal__button');
	          _modalClose.classList.add('modal__button--close');
	          _modalClose.addEventListener('click', function (e) {
	            e.preventDefault();
	            _this.hideModal();
	          });
	          _modalClose.addEventListener('mouseover', function (e) {
	            _gsap.TweenLite.to(e.target, 0.01, {
	              scale: 1.1,
	              ease: _this.animationEasing
	            });
	          });
	          _modalClose.addEventListener('mouseout', function (e) {
	            _gsap.TweenLite.to(e.target, 0.01, {
	              scale: 1,
	              ease: _this.animationEasing
	            });
	          });
	
	          var _modalContent = document.createElement('div');
	          _modalContent.classList.add('modal__content');
	          _modalContent.innerHTML = content;
	
	          var _modalQuiz = _this.getQuestion(page, modal);
	
	          _modalFragment.appendChild(_modalClose);
	          _modalFragment.appendChild(_modalContent);
	
	          if (_modalQuiz) {
	            _modalFragment.appendChild(_modalQuiz);
	          }
	
	          _this.modalContainerWrap.appendChild(_modalFragment);
	
	          if (_modalQuiz) {
	            _this.scores.updateAnswer(page, modal, null);
	          }
	
	          _this.showModal();
	        }).catch(function (error) {
	          console.log('Unable to get modal content: ' + error);
	        });
	      });
	
	      button.addEventListener('mouseover', function (e) {
	        e.target.style.animation = 'none';
	        _gsap.TweenLite.to(e.target, 0.01, {
	          scale: 1.1,
	          ease: _this.animationEasing
	        });
	      });
	
	      button.addEventListener('mouseout', function (e) {
	        _gsap.TweenLite.to(e.target, 0.01, {
	          scale: 1,
	          ease: _this.animationEasing
	        });
	      });
	
	      this.modalMask.addEventListener('click', function () {
	        return _this.hideModal();
	      });
	
	      window.addEventListener('keydown', function (e) {
	        if (e.key === 'Escape') {
	          _this.hideModal();
	        }
	      });
	    }
	  }, {
	    key: 'getQuestion',
	    value: function getQuestion(page, modal) {
	      if (this.scoreData[page] && this.scoreData[page][modal]) {
	        var quiz = this.scoreData[page][modal];
	
	        var _quizContent = document.createElement('div');
	        _quizContent.classList.add('quiz');
	        _quizContent.classList.add(page);
	        _quizContent.classList.add(modal);
	
	        var _quizBlock = document.createElement('div');
	        _quizBlock.classList.add('quiz__block');
	        _quizBlock.classList.add('quiz__block--question');
	
	        var _header = document.createElement('div');
	        _header.classList.add('quiz__content');
	
	        var _headerTitle = document.createElement('h2');
	        _headerTitle.innerText = 'Question';
	        _header.appendChild(_headerTitle);
	
	        var _headerQuestion = document.createElement('p');
	        _headerQuestion.innerHTML = quiz.question;
	        _header.appendChild(_headerQuestion);
	
	        var _footer = document.createElement('ul');
	        _footer.classList.add('quiz__options');
	
	        var i = 0;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(quiz.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var o = _step2.value;
	
	            var _footerOption = document.createElement('li');
	            _footerOption.classList.add('quiz__item');
	
	            var _optionButton = document.createElement('button');
	            _optionButton.setAttribute('type', 'button');
	            _optionButton.dataset.id = i + 1;
	            _optionButton.dataset.page = page;
	            _optionButton.dataset.modal = modal;
	            _optionButton.dataset.pip = this.scores.getLetter(i);
	            _optionButton.classList.add('quiz__button');
	            _footerOption.classList.add('quiz__button--' + o.size);
	            _optionButton.innerHTML = o.title;
	
	            _footerOption.appendChild(_optionButton);
	            _footer.appendChild(_footerOption);
	
	            i++;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        _quizBlock.appendChild(_header);
	        _quizBlock.appendChild(_footer);
	        _quizContent.appendChild(_quizBlock);
	
	        var _quizAnswer = this.getAnswer(page, modal, quiz);
	        _quizContent.appendChild(_quizAnswer);
	
	        return _quizContent;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getAnswer',
	    value: function getAnswer(page, modal, quiz) {
	      var _quizBlock = document.createElement('div');
	      _quizBlock.classList.add('quiz__block');
	      _quizBlock.classList.add('quiz__block--answer');
	
	      var _content = document.createElement('div');
	      _content.classList.add('quiz__content');
	
	      var _contentImage = document.createElement('figure');
	      _contentImage.classList.add('quiz__image');
	      _contentImage.classList.add('quiz__image--' + modal);
	      _content.appendChild(_contentImage);
	
	      var _contentTitle = document.createElement('h2');
	      _contentTitle.innerHTML = '<span class="quiz__title-type quiz__title-type--correct">Correct</span>' + '<span class="quiz__title-type quiz__title-type--incorrect">Incorrect</span>' + ' - ' + this.scores.getLetter(quiz.correct) + '';
	      _content.appendChild(_contentTitle);
	
	      var _contentSummary = document.createElement('p');
	      _contentSummary.innerText = quiz.answer;
	      _content.appendChild(_contentSummary);
	
	      _quizBlock.appendChild(_content);
	
	      return _quizBlock;
	    }
	  }, {
	    key: 'showButtons',
	    value: function showButtons(delay) {
	      var _this2 = this;
	
	      var i = 0;
	      var fadeIn = function fadeIn() {
	        _this2.buttons[i++].classList.add('modal__button--active');
	        if (i < _this2.buttons.length) {
	          setTimeout(function () {
	            requestAnimationFrame(fadeIn);
	          }, 200);
	        }
	      };
	      setTimeout(function () {
	        requestAnimationFrame(fadeIn);
	      }, delay);
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal() {
	      var _this3 = this;
	
	      _gsap.TweenLite.fromTo(this.modalContainer, this.animationSpeed, {
	        opacity: 0,
	        scale: this.animationScale.min,
	        y: '-50%',
	        ease: this.animationEasing
	      }, {
	        opacity: 1,
	        scale: this.animationScale.max,
	        y: '-50%',
	        ease: this.animationEasing,
	        onStart: function onStart() {
	          _this3.modalContainer.classList.add('modal-container--active');
	        }
	      });
	
	      _gsap.TweenLite.to(this.modalMask, this.animationSpeed, {
	        opacity: 1,
	        ease: this.animationEasing,
	        onStart: function onStart() {
	          _this3.modalMask.classList.add('modal-mask--active');
	        }
	      });
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      var _this4 = this;
	
	      _gsap.TweenLite.to(this.modalContainer, this.animationSpeed, {
	        opacity: 0,
	        scale: this.animationScale.max,
	        ease: this.animationEasing,
	        onComplete: function onComplete() {
	          _this4.modalContainer.classList.remove('modal-container--active');
	          _this4.modalContainerWrap.innerHTML = '';
	        }
	      });
	
	      _gsap.TweenLite.to(this.modalMask, this.animationSpeed, {
	        opacity: 0,
	        ease: this.animationEasing,
	        onComplete: function onComplete() {
	          _this4.modalMask.classList.remove('modal-mask--active');
	        }
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.buttons.length > 0) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(this.buttons), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var button = _step3.value;
	
	            this.modalController.removeChild(button);
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	    }
	  }]);
	  return Modals;
	}();
	
	exports.Modals = Modals;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sprites = undefined;
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _spriteAnim = __webpack_require__(191);
	
	var _spriteAnim2 = _interopRequireDefault(_spriteAnim);
	
	var _debounce = __webpack_require__(139);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Animation = function () {
	  function Animation(_ref) {
	    var element = _ref.element,
	        frames = _ref.frames,
	        frameRate = _ref.frameRate,
	        delay = _ref.delay,
	        interval = _ref.interval;
	    (0, _classCallCheck3.default)(this, Animation);
	
	    this.element = element;
	    this.width = this.element.offsetWidth;
	    this.height = this.element.offsetHeight;
	    this.frames = frames;
	    this.frameRate = frameRate;
	    this.delay = delay;
	    this.interval = interval;
	  }
	
	  (0, _createClass3.default)(Animation, [{
	    key: 'createPlayer',
	    value: function createPlayer() {
	      var _renderer = new _spriteAnim2.default.DOMRenderer(this.element);
	      var _parser = new _spriteAnim2.default.SimpleParser({
	        width: this.width * this.frames,
	        height: this.height
	      }, {
	        width: this.width,
	        height: this.height
	      });
	      this.player = new _spriteAnim2.default(_parser, _renderer, { frameRate: this.frameRate });
	    }
	  }, {
	    key: 'updateParser',
	    value: function updateParser() {
	      var _newWidth = this.element.offsetWidth;
	      var _newHeight = this.element.offsetHeight;
	
	      if (_newWidth !== this.width || _newHeight !== this.height) {
	        this.width = _newWidth;
	        this.height = _newHeight;
	
	        this.player.pause();
	        this.player.parser = new _spriteAnim2.default.SimpleParser({
	          width: this.width * this.frames,
	          height: this.height
	        }, {
	          width: this.width,
	          height: this.height
	        });
	        this.player.renderFrame();
	        this.player.play();
	      }
	    }
	  }]);
	  return Animation;
	}();
	
	var Sprites = function () {
	  function Sprites() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Sprites);
	
	    this.sprites = [];
	    this.activeClass = 'sprite--active';
	    this.timers = [];
	
	    window.addEventListener('resize', (0, _debounce2.default)(function () {
	      return _this.resizeAnimations();
	    }, 200));
	  }
	
	  (0, _createClass3.default)(Sprites, [{
	    key: 'animate',
	    value: function animate(page) {
	      if (this.sprites.length === 0 && window.matchMedia('(min-width: 1024px)').matches) {
	        var _parent = document.getElementById(page);
	        var _sprites = _parent.querySelectorAll('.sprite');
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(_sprites), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            var _sprite = {
	              element: item,
	              frames: item.getAttribute('data-frames'),
	              frameRate: item.getAttribute('data-framerate'),
	              delay: item.getAttribute('data-delay'),
	              interval: item.getAttribute('data-interval'),
	              isActive: true
	            };
	            this.sprites.push(_sprite);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	
	      this.initAnimations();
	    }
	  }, {
	    key: 'initAnimations',
	    value: function initAnimations() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.sprites), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var sprite = _step2.value;
	
	          if (sprite.animation === undefined) {
	            sprite.animation = new Animation(sprite);
	            sprite.animation.createPlayer();
	          }
	          sprite.isActive = true;
	          this.startAnimation(sprite);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'startAnimation',
	    value: function startAnimation(sprite) {
	      var _loop = function _loop() {
	        if (sprite.isActive) {
	          sprite.animation.player.gotoAndPlay(0);
	        }
	      };
	
	      sprite.element.classList.add(this.activeClass);
	
	      setTimeout(function () {
	        return sprite.animation.player.play();
	      }, sprite.delay);
	
	      sprite.animation.player.on('complete', function () {
	        setTimeout(_loop, sprite.interval);
	      });
	    }
	  }, {
	    key: 'resizeAnimations',
	    value: function resizeAnimations() {
	      if (this.sprites && this.sprites.length > 0) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(this.sprites), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var sprite = _step3.value;
	
	            sprite.animation.updateParser();
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(this.sprites), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var sprite = _step4.value;
	
	          sprite.element.classList.remove(this.activeClass);
	          sprite.animation.player.dispose();
	          sprite.isActive = false;
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }]);
	  return Sprites;
	}();
	
	exports.Sprites = Sprites;

/***/ },
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Animations = undefined;
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _gsap = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Animations = function () {
	  function Animations() {
	    (0, _classCallCheck3.default)(this, Animations);
	
	    this.activeAnimations = [];
	  }
	
	  (0, _createClass3.default)(Animations, [{
	    key: 'disable',
	    value: function disable() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.activeAnimations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var anim = _step.value;
	
	          anim.kill();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.activeAnimations = [];
	    }
	  }, {
	    key: 'spinTurbine',
	    value: function spinTurbine() {
	      var turbine = document.querySelectorAll('.anim--turbine');
	      var anim = _gsap.TweenMax.fromTo(turbine, 7, {
	        rotation: 0
	      }, {
	        rotation: 360,
	        ease: _gsap.Linear.easeNone,
	        repeat: -1
	      });
	      this.activeAnimations.push(anim);
	    }
	  }, {
	    key: 'moveClockHand',
	    value: function moveClockHand() {
	      var hand = document.querySelector('.clock__hand');
	      var steppedEase = new _gsap.SteppedEase(60);
	      var clock = _gsap.TweenMax.to(hand, 60, {
	        rotation: '360_cw',
	        ease: steppedEase,
	        repeat: -1
	      }, 0);
	      this.activeAnimations.push(clock);
	    }
	  }]);
	  return Animations;
	}();
	
	exports.Animations = Animations;

/***/ },
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/scene__clouds-2.6c41ad8.svg";

/***/ },
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/scene__sun.6eb60e9.svg";

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = function(scope, defaultValues, values){
	  for (var key in defaultValues){
	    scope[key] = typeof values[key] !== 'undefined' ? values[key] : defaultValues[key];
	  }
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = function(obj){
	  return Object.prototype.toString.call(obj) === '[object Array]';
	};

/***/ },
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows.eec3ea7.svg";

/***/ },
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/background.5c8e5e2.svg";

/***/ },
/* 81 */
/***/ function(module, exports) {

	//============================================================
	//
	// The MIT License
	//
	// Copyright (C) 2014 Matthew Wagerfield - @wagerfield
	//
	// Permission is hereby granted, free of charge, to any
	// person obtaining a copy of this software and associated
	// documentation files (the "Software"), to deal in the
	// Software without restriction, including without limitation
	// the rights to use, copy, modify, merge, publish, distribute,
	// sublicense, and/or sell copies of the Software, and to
	// permit persons to whom the Software is furnished to do
	// so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice
	// shall be included in all copies or substantial portions
	// of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY
	// OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
	// LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO
	// EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE
	// FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
	// AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	// OR OTHER DEALINGS IN THE SOFTWARE.
	//
	//============================================================
	
	/**
	 * Parallax.js
	 * @author Matthew Wagerfield - @wagerfield
	 * @description Creates a parallax effect between an array of layers,
	 *              driving the motion from the gyroscope output of a smartdevice.
	 *              If no gyroscope is available, the cursor position is used.
	 */
	;(function(window, document, undefined) {
	
	  // Strict Mode
	  'use strict';
	
	  // Constants
	  var NAME = 'Parallax';
	  var MAGIC_NUMBER = 30;
	  var DEFAULTS = {
	    relativeInput: false,
	    clipRelativeInput: false,
	    calibrationThreshold: 100,
	    calibrationDelay: 500,
	    supportDelay: 500,
	    calibrateX: false,
	    calibrateY: true,
	    invertX: true,
	    invertY: true,
	    limitX: false,
	    limitY: false,
	    scalarX: 10.0,
	    scalarY: 10.0,
	    frictionX: 0.1,
	    frictionY: 0.1,
	    originX: 0.5,
	    originY: 0.5
	  };
	
	  function Parallax(element, options) {
	
	    // DOM Context
	    this.element = element;
	    this.layers = element.getElementsByClassName('layer');
	
	    // Data Extraction
	    var data = {
	      calibrateX: this.data(this.element, 'calibrate-x'),
	      calibrateY: this.data(this.element, 'calibrate-y'),
	      invertX: this.data(this.element, 'invert-x'),
	      invertY: this.data(this.element, 'invert-y'),
	      limitX: this.data(this.element, 'limit-x'),
	      limitY: this.data(this.element, 'limit-y'),
	      scalarX: this.data(this.element, 'scalar-x'),
	      scalarY: this.data(this.element, 'scalar-y'),
	      frictionX: this.data(this.element, 'friction-x'),
	      frictionY: this.data(this.element, 'friction-y'),
	      originX: this.data(this.element, 'origin-x'),
	      originY: this.data(this.element, 'origin-y')
	    };
	
	    // Delete Null Data Values
	    for (var key in data) {
	      if (data[key] === null) delete data[key];
	    }
	
	    // Compose Settings Object
	    this.extend(this, DEFAULTS, options, data);
	
	    // States
	    this.calibrationTimer = null;
	    this.calibrationFlag = true;
	    this.enabled = false;
	    this.depths = [];
	    this.raf = null;
	
	    // Element Bounds
	    this.bounds = null;
	    this.ex = 0;
	    this.ey = 0;
	    this.ew = 0;
	    this.eh = 0;
	
	    // Element Center
	    this.ecx = 0;
	    this.ecy = 0;
	
	    // Element Range
	    this.erx = 0;
	    this.ery = 0;
	
	    // Calibration
	    this.cx = 0;
	    this.cy = 0;
	
	    // Input
	    this.ix = 0;
	    this.iy = 0;
	
	    // Motion
	    this.mx = 0;
	    this.my = 0;
	
	    // Velocity
	    this.vx = 0;
	    this.vy = 0;
	
	    // Callbacks
	    this.onMouseMove = this.onMouseMove.bind(this);
	    this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
	    this.onOrientationTimer = this.onOrientationTimer.bind(this);
	    this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
	    this.onAnimationFrame = this.onAnimationFrame.bind(this);
	    this.onWindowResize = this.onWindowResize.bind(this);
	
	    // Initialise
	    this.initialise();
	  }
	
	  Parallax.prototype.extend = function() {
	    if (arguments.length > 1) {
	      var master = arguments[0];
	      for (var i = 1, l = arguments.length; i < l; i++) {
	        var object = arguments[i];
	        for (var key in object) {
	          master[key] = object[key];
	        }
	      }
	    }
	  };
	
	  Parallax.prototype.data = function(element, name) {
	    return this.deserialize(element.getAttribute('data-'+name));
	  };
	
	  Parallax.prototype.deserialize = function(value) {
	    if (value === "true") {
	      return true;
	    } else if (value === "false") {
	      return false;
	    } else if (value === "null") {
	      return null;
	    } else if (!isNaN(parseFloat(value)) && isFinite(value)) {
	      return parseFloat(value);
	    } else {
	      return value;
	    }
	  };
	
	  Parallax.prototype.camelCase = function(value) {
	    return value.replace(/-+(.)?/g, function(match, character){
	      return character ? character.toUpperCase() : '';
	    });
	  };
	
	  Parallax.prototype.transformSupport = function(value) {
	    var element = document.createElement('div');
	    var propertySupport = false;
	    var propertyValue = null;
	    var featureSupport = false;
	    var cssProperty = null;
	    var jsProperty = null;
	    for (var i = 0, l = this.vendors.length; i < l; i++) {
	      if (this.vendors[i] !== null) {
	        cssProperty = this.vendors[i][0] + 'transform';
	        jsProperty = this.vendors[i][1] + 'Transform';
	      } else {
	        cssProperty = 'transform';
	        jsProperty = 'transform';
	      }
	      if (element.style[jsProperty] !== undefined) {
	        propertySupport = true;
	        break;
	      }
	    }
	    switch(value) {
	      case '2D':
	        featureSupport = propertySupport;
	        break;
	      case '3D':
	        if (propertySupport) {
	          var body = document.body || document.createElement('body');
	          var documentElement = document.documentElement;
	          var documentOverflow = documentElement.style.overflow;
	          if (!document.body) {
	            documentElement.style.overflow = 'hidden';
	            documentElement.appendChild(body);
	            body.style.overflow = 'hidden';
	            body.style.background = '';
	          }
	          body.appendChild(element);
	          element.style[jsProperty] = 'translate3d(1px,1px,1px)';
	          propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
	          featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== "none";
	          documentElement.style.overflow = documentOverflow;
	          body.removeChild(element);
	        }
	        break;
	    }
	    return featureSupport;
	  };
	
	  Parallax.prototype.ww = null;
	  Parallax.prototype.wh = null;
	  Parallax.prototype.wcx = null;
	  Parallax.prototype.wcy = null;
	  Parallax.prototype.wrx = null;
	  Parallax.prototype.wry = null;
	  Parallax.prototype.portrait = null;
	  Parallax.prototype.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
	  Parallax.prototype.vendors = [null,['-webkit-','webkit'],['-moz-','Moz'],['-o-','O'],['-ms-','ms']];
	  Parallax.prototype.motionSupport = !!window.DeviceMotionEvent;
	  Parallax.prototype.orientationSupport = !!window.DeviceOrientationEvent;
	  Parallax.prototype.orientationStatus = 0;
	  Parallax.prototype.transform2DSupport = Parallax.prototype.transformSupport('2D');
	  Parallax.prototype.transform3DSupport = Parallax.prototype.transformSupport('3D');
	  Parallax.prototype.propertyCache = {};
	
	  Parallax.prototype.initialise = function() {
	
	    // Configure Context Styles
	    if (this.transform3DSupport) this.accelerate(this.element);
	    var style = window.getComputedStyle(this.element);
	    if (style.getPropertyValue('position') === 'static') {
	      this.element.style.position = 'relative';
	    }
	
	    // Setup
	    this.updateLayers();
	    this.updateDimensions();
	    this.enable();
	    this.queueCalibration(this.calibrationDelay);
	  };
	
	  Parallax.prototype.updateLayers = function() {
	
	    // Cache Layer Elements
	    this.layers = this.element.getElementsByClassName('layer');
	    this.depths = [];
	
	    // Configure Layer Styles
	    for (var i = 0, l = this.layers.length; i < l; i++) {
	      var layer = this.layers[i];
	      if (this.transform3DSupport) this.accelerate(layer);
	      layer.style.position = i ? 'absolute' : 'relative';
	      layer.style.display = 'block';
	      layer.style.left = 0;
	      layer.style.top = 0;
	
	      // Cache Layer Depth
	      this.depths.push(this.data(layer, 'depth') || 0);
	    }
	  };
	
	  Parallax.prototype.updateDimensions = function() {
	    this.ww = window.innerWidth;
	    this.wh = window.innerHeight;
	    this.wcx = this.ww * this.originX;
	    this.wcy = this.wh * this.originY;
	    this.wrx = Math.max(this.wcx, this.ww - this.wcx);
	    this.wry = Math.max(this.wcy, this.wh - this.wcy);
	  };
	
	  Parallax.prototype.updateBounds = function() {
	    this.bounds = this.element.getBoundingClientRect();
	    this.ex = this.bounds.left;
	    this.ey = this.bounds.top;
	    this.ew = this.bounds.width;
	    this.eh = this.bounds.height;
	    this.ecx = this.ew * this.originX;
	    this.ecy = this.eh * this.originY;
	    this.erx = Math.max(this.ecx, this.ew - this.ecx);
	    this.ery = Math.max(this.ecy, this.eh - this.ecy);
	  };
	
	  Parallax.prototype.queueCalibration = function(delay) {
	    clearTimeout(this.calibrationTimer);
	    this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
	  };
	
	  Parallax.prototype.enable = function() {
	    if (!this.enabled) {
	      this.enabled = true;
	      if (this.orientationSupport) {
	        this.portrait = null;
	        window.addEventListener('deviceorientation', this.onDeviceOrientation);
	        setTimeout(this.onOrientationTimer, this.supportDelay);
	      } else {
	        this.cx = 0;
	        this.cy = 0;
	        this.portrait = false;
	        window.addEventListener('mousemove', this.onMouseMove);
	      }
	      window.addEventListener('resize', this.onWindowResize);
	      this.raf = requestAnimationFrame(this.onAnimationFrame);
	    }
	  };
	
	  Parallax.prototype.disable = function() {
	    if (this.enabled) {
	      this.enabled = false;
	      if (this.orientationSupport) {
	        window.removeEventListener('deviceorientation', this.onDeviceOrientation);
	      } else {
	        window.removeEventListener('mousemove', this.onMouseMove);
	      }
	      window.removeEventListener('resize', this.onWindowResize);
	      cancelAnimationFrame(this.raf);
	    }
	  };
	
	  Parallax.prototype.calibrate = function(x, y) {
	    this.calibrateX = x === undefined ? this.calibrateX : x;
	    this.calibrateY = y === undefined ? this.calibrateY : y;
	  };
	
	  Parallax.prototype.invert = function(x, y) {
	    this.invertX = x === undefined ? this.invertX : x;
	    this.invertY = y === undefined ? this.invertY : y;
	  };
	
	  Parallax.prototype.friction = function(x, y) {
	    this.frictionX = x === undefined ? this.frictionX : x;
	    this.frictionY = y === undefined ? this.frictionY : y;
	  };
	
	  Parallax.prototype.scalar = function(x, y) {
	    this.scalarX = x === undefined ? this.scalarX : x;
	    this.scalarY = y === undefined ? this.scalarY : y;
	  };
	
	  Parallax.prototype.limit = function(x, y) {
	    this.limitX = x === undefined ? this.limitX : x;
	    this.limitY = y === undefined ? this.limitY : y;
	  };
	
	  Parallax.prototype.origin = function(x, y) {
	    this.originX = x === undefined ? this.originX : x;
	    this.originY = y === undefined ? this.originY : y;
	  };
	
	  Parallax.prototype.clamp = function(value, min, max) {
	    value = Math.max(value, min);
	    value = Math.min(value, max);
	    return value;
	  };
	
	  Parallax.prototype.css = function(element, property, value) {
	    var jsProperty = this.propertyCache[property];
	    if (!jsProperty) {
	      for (var i = 0, l = this.vendors.length; i < l; i++) {
	        if (this.vendors[i] !== null) {
	          jsProperty = this.camelCase(this.vendors[i][1] + '-' + property);
	        } else {
	          jsProperty = property;
	        }
	        if (element.style[jsProperty] !== undefined) {
	          this.propertyCache[property] = jsProperty;
	          break;
	        }
	      }
	    }
	    element.style[jsProperty] = value;
	  };
	
	  Parallax.prototype.accelerate = function(element) {
	    this.css(element, 'transform', 'translate3d(0,0,0)');
	    this.css(element, 'transform-style', 'preserve-3d');
	    this.css(element, 'backface-visibility', 'hidden');
	  };
	
	  Parallax.prototype.setPosition = function(element, x, y) {
	    x += 'px';
	    y += 'px';
	    if (this.transform3DSupport) {
	      this.css(element, 'transform', 'translate3d('+x+','+y+',0)');
	    } else if (this.transform2DSupport) {
	      this.css(element, 'transform', 'translate('+x+','+y+')');
	    } else {
	      element.style.left = x;
	      element.style.top = y;
	    }
	  };
	
	  Parallax.prototype.onOrientationTimer = function(event) {
	    if (this.orientationSupport && this.orientationStatus === 0) {
	      this.disable();
	      this.orientationSupport = false;
	      this.enable();
	    }
	  };
	
	  Parallax.prototype.onCalibrationTimer = function(event) {
	    this.calibrationFlag = true;
	  };
	
	  Parallax.prototype.onWindowResize = function(event) {
	    this.updateDimensions();
	  };
	
	  Parallax.prototype.onAnimationFrame = function() {
	    this.updateBounds();
	    var dx = this.ix - this.cx;
	    var dy = this.iy - this.cy;
	    if ((Math.abs(dx) > this.calibrationThreshold) || (Math.abs(dy) > this.calibrationThreshold)) {
	      this.queueCalibration(0);
	    }
	    if (this.portrait) {
	      this.mx = this.calibrateX ? dy : this.iy;
	      this.my = this.calibrateY ? dx : this.ix;
	    } else {
	      this.mx = this.calibrateX ? dx : this.ix;
	      this.my = this.calibrateY ? dy : this.iy;
	    }
	    this.mx *= this.ew * (this.scalarX / 100);
	    this.my *= this.eh * (this.scalarY / 100);
	    if (!isNaN(parseFloat(this.limitX))) {
	      this.mx = this.clamp(this.mx, -this.limitX, this.limitX);
	    }
	    if (!isNaN(parseFloat(this.limitY))) {
	      this.my = this.clamp(this.my, -this.limitY, this.limitY);
	    }
	    this.vx += (this.mx - this.vx) * this.frictionX;
	    this.vy += (this.my - this.vy) * this.frictionY;
	    for (var i = 0, l = this.layers.length; i < l; i++) {
	      var layer = this.layers[i];
	      var depth = this.depths[i];
	      var xOffset = this.vx * depth * (this.invertX ? -1 : 1);
	      var yOffset = this.vy * depth * (this.invertY ? -1 : 1);
	      this.setPosition(layer, xOffset, yOffset);
	    }
	    this.raf = requestAnimationFrame(this.onAnimationFrame);
	  };
	
	  Parallax.prototype.onDeviceOrientation = function(event) {
	
	    // Validate environment and event properties.
	    if (!this.desktop && event.beta !== null && event.gamma !== null) {
	
	      // Set orientation status.
	      this.orientationStatus = 1;
	
	      // Extract Rotation
	      var x = (event.beta  || 0) / MAGIC_NUMBER; //  -90 :: 90
	      var y = (event.gamma || 0) / MAGIC_NUMBER; // -180 :: 180
	
	      // Detect Orientation Change
	      var portrait = this.wh > this.ww;
	      if (this.portrait !== portrait) {
	        this.portrait = portrait;
	        this.calibrationFlag = true;
	      }
	
	      // Set Calibration
	      if (this.calibrationFlag) {
	        this.calibrationFlag = false;
	        this.cx = x;
	        this.cy = y;
	      }
	
	      // Set Input
	      this.ix = x;
	      this.iy = y;
	    }
	  };
	
	  Parallax.prototype.onMouseMove = function(event) {
	
	    // Cache mouse coordinates.
	    var clientX = event.clientX;
	    var clientY = event.clientY;
	
	    // Calculate Mouse Input
	    if (!this.orientationSupport && this.relativeInput) {
	
	      // Clip mouse coordinates inside element bounds.
	      if (this.clipRelativeInput) {
	        clientX = Math.max(clientX, this.ex);
	        clientX = Math.min(clientX, this.ex + this.ew);
	        clientY = Math.max(clientY, this.ey);
	        clientY = Math.min(clientY, this.ey + this.eh);
	      }
	
	      // Calculate input relative to the element.
	      this.ix = (clientX - this.ex - this.ecx) / this.erx;
	      this.iy = (clientY - this.ey - this.ecy) / this.ery;
	
	    } else {
	
	      // Calculate input relative to the window.
	      this.ix = (clientX - this.wcx) / this.wrx;
	      this.iy = (clientY - this.wcy) / this.wry;
	    }
	  };
	
	  // Expose Parallax
	  window[NAME] = Parallax;
	
	})(window, document);
	
	/**
	 * Request Animation Frame Polyfill.
	 * @author Tino Zijdel
	 * @author Paul Irish
	 * @see https://gist.github.com/paulirish/1579671
	 */
	;(function() {
	
	  var lastTime = 0;
	  var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	  }
	
	  if (!window.requestAnimationFrame) {
	    window.requestAnimationFrame = function(callback, element) {
	      var currTime = new Date().getTime();
	      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	      var id = window.setTimeout(function() { callback(currTime + timeToCall); },
	        timeToCall);
	      lastTime = currTime + timeToCall;
	      return id;
	    };
	  }
	
	  if (!window.cancelAnimationFrame) {
	    window.cancelAnimationFrame = function(id) {
	      clearTimeout(id);
	    };
	  }
	
	}());


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoopElement = undefined;
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _gsap = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoopElement = function () {
	  function LoopElement(selector, duration) {
	    (0, _classCallCheck3.default)(this, LoopElement);
	
	    this.init = false;
	    this.timeline = new _gsap.TimelineLite({ paused: true });
	    this.selector = selector;
	    this.duration = duration;
	  }
	
	  (0, _createClass3.default)(LoopElement, [{
	    key: 'animate',
	    value: function animate(page) {
	      var _page = document.getElementById(page);
	      var _element = _page.querySelector(this.selector);
	      var _parent = _element.parentNode;
	
	      if (_element !== null) {
	        var _parentWidth = _parent.offsetWidth;
	        var _elementWidth = _element.offsetWidth;
	        var _elementPos = _element.offsetLeft;
	
	        this.timeline.to(_element, this.duration, {
	          x: _parentWidth + _elementWidth,
	          ease: _gsap.Linear.easeNone
	        }, 0);
	
	        this.timeline.fromTo(_element, this.duration, {
	          x: -Math.abs(_elementPos + _elementWidth),
	          ease: _gsap.Linear.easeNone,
	          immediateRender: false
	        }, {
	          x: _parentWidth + _elementWidth,
	          ease: _gsap.Linear.easeNone,
	          repeat: -1
	        });
	
	        this.timeline.play();
	      } else {
	        console.log('Animated element doesn\'t exist');
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      this.timeline.kill();
	    }
	  }]);
	  return LoopElement;
	}();
	
	exports.LoopElement = LoopElement;

/***/ },
/* 83 */,
/* 84 */,
/* 85 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'start': [],
	  'intro': [{ 'type': 'quiz', 'x': '26%', 'y': '58%', 'modal': 'intro-bike' }, { 'type': 'quiz', 'x': '37%', 'y': '43%', 'modal': 'intro-pupils' }, { 'type': 'quiz', 'x': '51%', 'y': '55%', 'modal': 'intro-trees' }, { 'type': 'quiz', 'x': '62%', 'y': '26%', 'modal': 'intro-solar' }, { 'type': 'quiz', 'x': '76%', 'y': '59%', 'modal': 'intro-bin' }],
	  'school-grounds': [{ 'type': 'quiz', 'x': '10%', 'y': '33%', 'modal': 'bird-feeders' }, { 'type': 'quiz', 'x': '31%', 'y': '35%', 'modal': 'polytunnel' }, { 'type': 'quiz', 'x': '61%', 'y': '57%', 'modal': 'composting' }, { 'type': 'quiz', 'x': '70%', 'y': '26.5%', 'modal': 'green-roof' }, { 'type': 'quiz', 'x': '88%', 'y': '59%', 'modal': 'water-butt' }],
	  'classroom': [{ 'type': 'quiz', 'x': '16%', 'y': '48%', 'modal': 'computers' }, { 'type': 'quiz', 'x': '30%', 'y': '61%', 'modal': 'recycling-paper' }, { 'type': 'quiz', 'x': '38%', 'y': '61%', 'modal': 'recycling-plastic' }, { 'type': 'quiz', 'x': '55.5%', 'y': '54%', 'modal': 'water-bottle' }, { 'type': 'quiz', 'x': '60%', 'y': '35%', 'modal': 'books' }],
	  'corridor': [{ 'type': 'quiz', 'x': '13%', 'y': '37%', 'modal': 'posters' }, { 'type': 'quiz', 'x': '33%', 'y': '16%', 'modal': 'lights' }, { 'type': 'quiz', 'x': '49%', 'y': '34%', 'modal': 'noticeboard' }, { 'type': 'quiz', 'x': '60%', 'y': '57%', 'modal': 'crisp-bin' }, { 'type': 'quiz', 'x': '67.7%', 'y': '61%', 'modal': 'litter-pickers' }],
	  'bathroom': [{ 'type': 'quiz', 'x': '15%', 'y': '50%', 'modal': 'cistern' }, { 'type': 'quiz', 'x': '36%', 'y': '46%', 'modal': 'toilet' }, { 'type': 'quiz', 'x': '58%', 'y': '40%', 'modal': 'hand-dryer' }, { 'type': 'quiz', 'x': '71%', 'y': '41%', 'modal': 'hand-soap' }, { 'type': 'quiz', 'x': '78%', 'y': '49%', 'modal': 'sensor-taps' }],
	  'canteen': [{ 'type': 'quiz', 'x': '20.5%', 'y': '57%', 'modal': 'meals' }, { 'type': 'quiz', 'x': '32%', 'y': '35%', 'modal': 'staff' }, { 'type': 'quiz', 'x': '32%', 'y': '25%', 'modal': 'fairtrade-food' }, { 'type': 'quiz', 'x': '65%', 'y': '45%', 'modal': 'cups-plates' }, { 'type': 'quiz', 'x': '73%', 'y': '55%', 'modal': 'recycling-bins' }]
	};

/***/ },
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Clouds = __webpack_require__(5);
	
	var _Animations = __webpack_require__(16);
	
	var _Scores = __webpack_require__(19);
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var clouds = new _Clouds.Clouds([['.scene__cloud--first', 130], ['.scene__cloud--second', 90], ['.scene__cloud--third', 80], ['.scene__cloud--fourth', 110]]);
	var animations = new _Animations.Animations();
	var scores = new _Scores.Scores();
	
	exports.default = {
	  name: 'view-start',
	  data: function data() {
	    return {
	      right: '0',
	      wrong: '0',
	      total: '0',
	      score: '0',
	      showResults: false
	    };
	  },
	
	  methods: {
	    checkResults: function checkResults() {
	      console.log(scores);
	      if (scores.progress === scores.total) {
	        this.showResults = true;
	        this.right = scores.right;
	        this.wrong = scores.wrong;
	        this.total = scores.total;
	        this.score = scores.score;
	      } else {
	        this.showResults = false;
	        this.right = 0;
	        this.wrong = 0;
	        this.total = 0;
	        this.score = 0;
	      }
	    }
	  },
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	        _this.checkResults();
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    parallax.disable();
	    clouds.disable();
	    animations.disable();
	  }
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Modals = __webpack_require__(11);
	
	var _Clouds = __webpack_require__(5);
	
	var _Sprites = __webpack_require__(12);
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var modals = new _Modals.Modals();
	var clouds = new _Clouds.Clouds([['.window__cloud--first', 160], ['.window__cloud--second', 120], ['.window__cloud--third', 110], ['.window__cloud--fourth', 150], ['.window__cloud--fifth', 130]]);
	var sprites = new _Sprites.Sprites();
	
	exports.default = {
	  name: 'view-5',
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        modals.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	        sprites.animate(_this.$route.name);
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    modals.remove();
	
	    parallax.disable();
	    clouds.disable();
	    sprites.disable();
	  }
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Modals = __webpack_require__(11);
	
	var _Clouds = __webpack_require__(5);
	
	var _Sprites = __webpack_require__(12);
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var modals = new _Modals.Modals();
	var clouds = new _Clouds.Clouds([['.window__cloud--first', 60], ['.window__cloud--second', 70], ['.window__cloud--third', 110]]);
	var sprites = new _Sprites.Sprites();
	
	exports.default = {
	  name: 'view-7',
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        modals.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	        sprites.animate(_this.$route.name);
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    modals.remove();
	
	    parallax.disable();
	    clouds.disable();
	    sprites.disable();
	  }
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Modals = __webpack_require__(11);
	
	var _Clouds = __webpack_require__(5);
	
	var _Sprites = __webpack_require__(12);
	
	var _Animations = __webpack_require__(16);
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var modals = new _Modals.Modals();
	var clouds = new _Clouds.Clouds([['.window__cloud--first', 60], ['.window__cloud--second', 80], ['.window__cloud--third', 110]]);
	var sprites = new _Sprites.Sprites();
	var animations = new _Animations.Animations();
	
	exports.default = {
	  name: 'view-3',
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        modals.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	        sprites.animate(_this.$route.name);
	        animations.moveClockHand();
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    modals.remove();
	
	    parallax.disable();
	    clouds.disable();
	    sprites.disable();
	    animations.disable();
	  }
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Modals = __webpack_require__(11);
	
	var _Clouds = __webpack_require__(5);
	
	var _Sprites = __webpack_require__(12);
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var modals = new _Modals.Modals();
	var clouds = new _Clouds.Clouds([['.window__cloud--first', 160], ['.window__cloud--second', 120], ['.window__cloud--third', 110], ['.window__cloud--fourth', 150], ['.window__cloud--fifth', 130], ['.window__cloud--sixth', 120]]);
	var sprites = new _Sprites.Sprites();
	
	exports.default = {
	  name: 'view-4',
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        modals.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	        sprites.animate(_this.$route.name);
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    modals.remove();
	
	    parallax.disable();
	    clouds.disable();
	    sprites.disable();
	  }
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Modals = __webpack_require__(11);
	
	var _Clouds = __webpack_require__(5);
	
	var _Sprites = __webpack_require__(12);
	
	var _Animations = __webpack_require__(16);
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var modals = new _Modals.Modals();
	var clouds = new _Clouds.Clouds([['.scene__cloud--first', 130], ['.scene__cloud--second', 90], ['.scene__cloud--third', 80], ['.scene__cloud--fourth', 110]]);
	var sprites = new _Sprites.Sprites();
	var animations = new _Animations.Animations();
	
	exports.default = {
	  name: 'view-1',
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        modals.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	        sprites.animate(_this.$route.name);
	        animations.spinTurbine();
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    modals.remove();
	
	    parallax.disable();
	    clouds.disable();
	    sprites.disable();
	    animations.disable();
	  }
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Modals = __webpack_require__(11);
	
	var _Clouds = __webpack_require__(5);
	
	var _Sprites = __webpack_require__(12);
	
	var _Animations = __webpack_require__(16);
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var modals = new _Modals.Modals();
	var clouds = new _Clouds.Clouds([['.scene__cloud--first', 130], ['.scene__cloud--second', 90], ['.scene__cloud--third', 80]]);
	var sprites = new _Sprites.Sprites();
	var animations = new _Animations.Animations();
	
	exports.default = {
	  name: 'view-1',
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        modals.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	        sprites.animate(_this.$route.name);
	        animations.spinTurbine();
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    modals.remove();
	
	    parallax.disable();
	    clouds.disable();
	    sprites.disable();
	    animations.disable();
	  }
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(26);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _ParallaxClass = __webpack_require__(6);
	
	var _Clouds = __webpack_require__(5);
	
	var _Animations = __webpack_require__(16);
	
	var _Scores = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var parallax = new _ParallaxClass.ParallaxClass();
	var clouds = new _Clouds.Clouds([['.scene__cloud--first', 130], ['.scene__cloud--second', 90], ['.scene__cloud--third', 80], ['.scene__cloud--fourth', 110]]);
	var animations = new _Animations.Animations();
	var scores = new _Scores.Scores();
	
	exports.default = {
	  name: 'view-start',
	  methods: {
	    goStart: function goStart() {
	      var path = '';
	      for (var i = 0; i < _routes2.default.length; i++) {
	        if (_routes2.default[i].type === 'scene') {
	          path = _routes2.default[i];
	          break;
	        }
	      }
	
	      scores.clearAnswers();
	      this.$router.push({ name: path.name });
	    },
	    privacyPosition: function privacyPosition() {
	      var pos = '0';
	      var vpHeight = window.innerHeight;
	      var privacyLink = document.querySelector('.start-privacy');
	      if (privacyLink) {
	        if (window.matchMedia('(max-width: 1024px)').matches) {
	          pos = '0';
	        } else if (window.matchMedia('(max-width: 1366px) and (max-height: 768px)').matches) {
	          pos = (768 - vpHeight) / 2 + 'px';
	        } else if (window.matchMedia('(min-width: 1367px) and (max-height: 1080px)').matches) {
	          pos = (1080 - vpHeight) / 2 + 'px';
	        }
	
	        privacyLink.style.bottom = pos;
	      }
	    }
	  },
	  activated: function activated() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        parallax.addToPage(_this.$route.name);
	        clouds.animate(_this.$route.name);
	
	        window.addEventListener('resize', function () {
	          return _this.privacyPosition();
	        });
	        _this.privacyPosition();
	      }, 500);
	    });
	  },
	  deactivated: function deactivated() {
	    parallax.disable();
	    clouds.disable();
	    animations.disable();
	  }
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(103), __esModule: true };

/***/ },
/* 99 */,
/* 100 */,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(98);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 102 */,
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(37);
	__webpack_require__(36);
	module.exports = __webpack_require__(134);

/***/ },
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(28)
	  , ITERATOR  = __webpack_require__(2)('iterator')
	  , Iterators = __webpack_require__(15);
	module.exports = __webpack_require__(4).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ },
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var now = __webpack_require__(140);
	
	/**
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing.
	 *
	 * @source underscore.js
	 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
	 * @param {Function} function to wrap
	 * @param {Number} timeout in ms (`100`)
	 * @param {Boolean} whether to execute at the beginning (`false`)
	 * @api public
	 */
	
	module.exports = function debounce(func, wait, immediate){
	  var timeout, args, context, timestamp, result;
	  if (null == wait) wait = 100;
	
	  function later() {
	    var last = now() - timestamp;
	
	    if (last < wait && last > 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = now();
	    var callNow = immediate && !timeout;
	    if (!timeout) timeout = setTimeout(later, wait);
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	
	    return result;
	  };
	};


/***/ },
/* 140 */
/***/ function(module, exports) {

	module.exports = Date.now || now
	
	function now() {
	    return new Date().getTime()
	}


/***/ },
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/clock__hand.2ce2b15.svg";

/***/ },
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/button.d0a9546.svg";

/***/ },
/* 185 */,
/* 186 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)))

/***/ },
/* 188 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(187)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 190 */,
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaultValues = __webpack_require__(42);
	
	var TinyEmitter = __webpack_require__(229);
	var inherits = __webpack_require__(186);
	var Ticker = __webpack_require__(192);
	
	var ticker = new Ticker();
	
	var SpriteAnim = function(parser, renderer, options) {
	  options = options || {};
	
	  this.parser = parser;
	  this.renderer = renderer;
	
	  var defaultOptions = {
	    manualUpdate: false,
	    frameRate: 60,
	    loop: false,
	    yoyo: false,
	    numFrames: parser.numFrames
	  };
	
	  defaultValues(this, defaultOptions, options);
	
	  this.lastFrame = this.numFrames - 1;
	
	  this.enterFrameId = -1;
	  this.enterFrameCb = this.onEnterFrame.bind(this);
	
	  this.currentFrame = 0;
	  this.isPlaying = false;
	  this.reversed = false;
	  this.complete = false;
	
	  this.lastFrameTime = 0;
	  this.interval = 1000 / this.frameRate;
	
	  this.x = 0;
	  this.y = 0;
	
	  this.alpha = 1;
	
	  return this;
	};
	
	inherits(SpriteAnim, TinyEmitter);
	
	SpriteAnim.prototype.play = function() {
	  this.isPlaying = true;
	  this.complete = false;
	
	  if(!this.manualUpdate) {
	    this.enterFrameId = ticker.add(this.enterFrameCb);
	  }
	
	  return this;
	};
	
	SpriteAnim.prototype.pause = function() {
	  this.isPlaying = false;
	
	  if(!this.manualUpdate) {
	    ticker.remove(this.enterFrameId);
	  }
	
	  return this;
	};
	
	SpriteAnim.prototype.stop = function() {
	  this.pause();
	  this.currentFrame = 0;
	
	  return this;
	};
	
	SpriteAnim.prototype.gotoAndPlay = function(frame) {
	  this.currentFrame = frame;
	  this.complete = false;
	
	  if (!this.isPlaying) this.play();
	
	  return this;
	};
	
	SpriteAnim.prototype.gotoAndStop = function(frame) {
	  if (this.isPlaying) this.pause();
	  this.currentFrame = frame;
	
	  this.renderFrame();
	
	  return this;
	};
	
	SpriteAnim.prototype.nextFrame = function() {
	  this.currentFrame++;
	  if (this.currentFrame > this.lastFrame) this.currentFrame = this.lastFrame;
	  if (this.currentFrame >= this.lastFrame) this.complete = true;
	
	  return this;
	};
	
	SpriteAnim.prototype.prevFrame = function() {
	  this.currentFrame--;
	  if (this.currentFrame < 0) this.currentFrame = 0;
	  if (this.currentFrame <= 0) this.complete = true;
	
	  return this;
	};
	
	SpriteAnim.prototype.renderFrame = function() {
	  this.renderer.render(this.parser.frames[this.currentFrame], this);
	
	  return this;
	};
	
	SpriteAnim.prototype.dispose = function() {
	  this.stop();
	  this.off('complete').off('enterFrame');
	
	  return this;
	};
	
	SpriteAnim.prototype.onComplete = function() {
	  if (this.loop) {
	    if (this.yoyo) this.reversed = !this.reversed;
	
	    if (!this.reversed) this.gotoAndPlay(0);
	    else this.gotoAndPlay(this.lastFrame);
	  } else {
	    this.pause();
	  }
	
	  this.emit('complete');
	
	  return this;
	};
	
	SpriteAnim.prototype.onEnterFrame = function(timeStamp) {
	  if (timeStamp - this.lastFrameTime > this.interval || this.lastFrameTime === 0) {
	    this.lastFrameTime = timeStamp;
	
	    if (!this.manualUpdate) this.renderFrame();
	
	    if (this.complete) {
	      this.onComplete();
	      return;
	    }
	
	    if (this.isPlaying){
	      if (!this.reversed) this.nextFrame();
	      else this.prevFrame();
	    }
	
	    this.emit('enterFrame');
	  }
	
	  return this;
	};
	
	module.exports = SpriteAnim;
	
	module.exports.CanvasRenderer = __webpack_require__(195);
	module.exports.OffScreenCanvasRenderer = __webpack_require__(197);
	module.exports.DOMRenderer = __webpack_require__(196);
	
	module.exports.SimpleParser = __webpack_require__(194);
	module.exports.JSONArrayParser = __webpack_require__(193);


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var raf = __webpack_require__(189);
	
	var itemId = 0;
	
	var Ticker = function(){
	  this.items = [];
	
	  this.isRunning = false;
	  this.tickId = -1;
	  this.tickCb = this.onTick.bind(this);
	};
	
	Ticker.prototype.start = function() {
	  this.isRunning = true;
	  
	  this.tickId = raf(this.tickCb);
	};
	
	Ticker.prototype.pause = function() {
	  this.isRunning = false;
	
	  raf.cancel(this.tickId);
	};
	
	Ticker.prototype.add = function(callback) {
	  var id = itemId++;
	
	  this.items.push({
	    id: id,
	    cb: callback
	  });
	
	  if (!this.isRunning) this.start();
	
	  return id;
	};
	
	Ticker.prototype.remove = function(id) {
	  var item;
	
	  for (var i = 0, n = this.items.length; i < n; i++){
	    if (this.items[i].id === id){
	      item = this.items.splice(i, 1)[0];
	      break;
	    }
	  }
	  
	  if (this.items.length === 0) this.pause();
	
	  return item;
	};
	
	Ticker.prototype.onTick = function(timeStamp) {
	  this.tickId = raf(this.tickCb);
	  
	  for (var i = 0, n = this.items.length; i < n; i++){
	    if (this.items[i]) this.items[i].cb(timeStamp);
	  }
	};
	
	module.exports = Ticker;
	


/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	var JSONArrayParser = function(data, scaleFactor){
	  scaleFactor = scaleFactor || 1;
	
	  this.frames = [];
	  this.numFrames = data.frames.length;
	
	  var frame;
	
	  for (var i = 0; i < this.numFrames; i++){
	    frame = data.frames[i].frame;
	
	    this.frames.push({
	      index: i,
	      x: frame.x * scaleFactor,
	      y: frame.y * scaleFactor,
	      width: frame.w * scaleFactor,
	      height: frame.h * scaleFactor
	    });
	  }
	};
	
	module.exports = JSONArrayParser;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArray = __webpack_require__(43);
	
	var SimpleParser = function(sprite, frameSize, options){
	  this.frameSize = frameSize;
	
	  this.options = options || {};
	  this.scaleFactor = this.options.scaleFactor || 1;
	  this.numFrames = this.options.numFrames;
	
	  this.frames = [];
	
	  if (isArray(sprite)){
	    for (var i = 0, n = sprite.length; i < n; i++){
	      this.initSpriteFrames(sprite[i], i);
	    }
	  }else{
	    this.initSpriteFrames(sprite, 0);
	  }
	
	  if (!this.numFrames) this.numFrames = this.frames.length;
	};
	
	SimpleParser.prototype.initSpriteFrames = function(sprite, spriteIndex){
	  var spriteWidth = sprite.naturalWidth || sprite.width;
	  var spriteHeight = sprite.naturalHeight || sprite.height;
	
	  spriteWidth *= this.scaleFactor;
	  spriteHeight *= this.scaleFactor;
	
	  var numFramesX = Math.ceil(spriteWidth / this.frameSize.width);
	  var numFramesY = Math.ceil(spriteHeight / this.frameSize.height);
	
	  loopY: 
	  for (var i = 0; i < numFramesY; i++) {
	
	    for (var j = 0; j < numFramesX; j++) {
	      this.frames.push({
	        x: j * this.frameSize.width,
	        y: i * this.frameSize.height,
	        index: this.frames.length,
	        width: this.frameSize.width,
	        height: this.frameSize.height,
	        spriteIndex: spriteIndex
	      });
	
	      if (this.frames.length === this.numFrames) break loopY;
	    }
	    
	  }
	};
	
	module.exports = SimpleParser;
	


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaultValues = __webpack_require__(42);
	var isArray = __webpack_require__(43);
	
	var CanvasRenderer = function(canvas, sprite, options){
	  options = options || {};
	
	  var defaultOptions = {
	    clearFrame: true
	  };
	
	  defaultValues(this, defaultOptions, options);
	
	  this.canvas = canvas;
	
	  if (isArray(sprite)){
	    this.sprites = sprite;
	  }else{
	    this.sprites = [sprite];
	  }
	
	  this.sprite = sprite;
	
	  this.context = canvas.getContext('2d');
	};
	
	CanvasRenderer.prototype.render = function(frame, animation) {
	  if (this.clearFrame) this.context.clearRect(0, 0, frame.width, frame.height);
	
	  this.context.globalAlpha = animation.alpha;
	
	  this.context.drawImage(
	    this.sprites[frame.spriteIndex],
	    frame.x,
	    frame.y,
	    frame.width,
	    frame.height,
	    animation.x,
	    animation.y,
	    frame.width,
	    frame.height
	   );
	};
	
	module.exports = CanvasRenderer;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArray = __webpack_require__(43);
	
	var DOMRenderer = function(element, options){
	  options = options || {};
	
	  this.element = element;
	
	  this.scaleFactor = options.scaleFactor || 1;
	  this.sprite = options.sprite;
	
	  this.spriteIndex = 0;
	  if (this.sprite) this.updateSprite();
	};
	
	DOMRenderer.prototype.updateSprite = function() {
	  var sprite;
	
	  if (isArray(this.sprite)){
	    sprite = this.sprite[this.spriteIndex];
	  }else{
	    sprite = this.sprite;
	  }
	
	  var spriteWidth = sprite.naturalWidth * this.scaleFactor;
	  var spriteHeight = sprite.naturalHeight * this.scaleFactor;
	
	  this.element.style.backgroundImage = 'url(' + sprite.src + ')';
	  this.element.style.backgroundSize = spriteWidth + 'px ' + spriteHeight + 'px';
	};
	
	DOMRenderer.prototype.render = function(frame) {
	  if (frame.spriteIndex !== this.spriteIndex){
	    this.spriteIndex = frame.spriteIndex;
	
	    this.updateSprite();
	  }
	
	  this.element.style.backgroundPosition = '-' + frame.x * this.scaleFactor + 'px -' + frame.y * this.scaleFactor + 'px';
	};
	
	module.exports = DOMRenderer;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaultValues = __webpack_require__(42);
	
	var OffScreenCanvasRenderer = function(canvas, sprite, options){
	  options = options || {};
	
	  this.canvas = canvas;
	  this.sprite = sprite;
	
	  var defaultOptions = {
	    clearFrame: true
	  };
	
	  defaultValues(this, defaultOptions, options);
	  
	  this.buffer = document.createElement('canvas');
	  this.buffer.width = sprite.width;
	  this.buffer.height = sprite.height;
	
	  this.bufferContext = this.buffer.getContext('2d');
	  this.bufferContext.drawImage(sprite, 0, 0);
	
	  this.context = canvas.getContext('2d');
	};
	
	OffScreenCanvasRenderer.prototype.render = function(frame, animation) {
	  if (this.clearFrame) this.context.clearRect(0, 0, frame.width, frame.height);
	
	  this.context.globalAlpha = animation.alpha;
	  
	  this.context.putImageData(
	    this.bufferContext.getImageData(frame.x,frame.y,frame.width,frame.height),
	    animation.x,
	    animation.y,
	    0,
	    0,
	    frame.width,
	    frame.height
	   );
	};
	
	module.exports = OffScreenCanvasRenderer;

/***/ },
/* 198 */
/***/ function(module, exports) {

	(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.TinyEmitter = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
	function E () {
		// Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
		on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;
	
	},{}]},{},[1])(1)
	});

/***/ },
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(90)
	
	/* template */
	var __vue_template__ = __webpack_require__(217)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(91)
	
	/* template */
	var __vue_template__ = __webpack_require__(216)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(92)
	
	/* template */
	var __vue_template__ = __webpack_require__(223)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(93)
	
	/* template */
	var __vue_template__ = __webpack_require__(218)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(94)
	
	/* template */
	var __vue_template__ = __webpack_require__(213)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(95)
	
	/* template */
	var __vue_template__ = __webpack_require__(220)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(96)
	
	/* template */
	var __vue_template__ = __webpack_require__(222)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(97)
	
	/* template */
	var __vue_template__ = __webpack_require__(221)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 212 */,
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "corridor"
	    }
	  }, [_h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--pupil",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "30",
	      "data-delay": "1000",
	      "data-interval": "5000"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--foreground",
	    attrs: {
	      "src": __webpack_require__(67),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--midground",
	    attrs: {
	      "data-depth": "0.2"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--watertank",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "17",
	      "data-delay": "2500",
	      "data-interval": "10000"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--noticeboard",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "20",
	      "data-delay": "3500",
	      "data-interval": "5000"
	    }
	  }), " ", _h('img', {
	    staticClass: "window__frames",
	    attrs: {
	      "src": __webpack_require__(69),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--midground",
	    attrs: {
	      "src": __webpack_require__(68),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "1"
	    }
	  }, [_h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(66),
	      "alt": ""
	    }
	  }), " ", _h('div', {
	    staticClass: "window__clouds"
	  }, [_h('img', {
	    staticClass: "window__cloud window__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--second",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--third",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--fourth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--fifth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--sixth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  })])]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  })])])
	}]}

/***/ },
/* 214 */,
/* 215 */,
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "bathroom"
	    }
	  }, [_h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--door",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "15",
	      "data-delay": "1000",
	      "data-interval": "3000"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--girl",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "20",
	      "data-delay": "0",
	      "data-interval": "0"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--foreground",
	    attrs: {
	      "src": __webpack_require__(58),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "0.1"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--dryer",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "20",
	      "data-delay": "0",
	      "data-interval": "0"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(57),
	      "alt": ""
	    }
	  }), " ", _h('div', {
	    staticClass: "window__clouds"
	  }, [_h('img', {
	    staticClass: "window__cloud window__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--second",
	    attrs: {
	      "src": __webpack_require__(18),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--third",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--fourth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--fifth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  })])]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  })])])
	}]}

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "conclusion"
	    }
	  }, [_vm._m(0), " ", (!_vm.showResults) ? _h('div', {
	    staticClass: "finish-continue"
	  }, [_h('div', {
	    staticClass: "finish-continue__frame"
	  }, [_h('div', {
	    staticClass: "finish-continue__block"
	  }, [_h('div', {
	    staticClass: "finish-continue__block-wrap"
	  }, [_h('h2', ["Continue your progress"]), " ", _h('p', ["You haven't finished answering all of the questions"]), " ", _h('p', [_h('router-link', {
	    staticClass: "finish__button",
	    attrs: {
	      "to": {
	        name: 'intro'
	      }
	    }
	  }, ["Return to the quiz"])])])])])]) : _vm._e(), " ", (_vm.showResults) ? _h('div', {
	    staticClass: "finish-results"
	  }, [_h('div', {
	    staticClass: "finish-results__frame"
	  }, [_vm._m(1), " ", _h('div', {
	    staticClass: "finish-results__block finish-results__block--half finish-results__block--score"
	  }, [_h('div', {
	    staticClass: "finish-results__block-wrap"
	  }, [_h('h2', ["Your Score"]), " ", _h('p', {
	    staticClass: "finish-results__score"
	  }, [_vm._s(_vm.score) + "%"]), " ", _h('p', ["You answered " + _vm._s(_vm.right) + "/" + _vm._s(_vm.total), _h('br'), " questions correctly"])])]), " ", _vm._m(2)]), " ", _h('div', {
	    staticClass: "finish-results__frame finish-results__return"
	  }, [_h('div', {
	    staticClass: "finish-results__block"
	  }, [_h('div', {
	    staticClass: "finish-results__block-wrap"
	  }, [_h('h2', ["Become an Eco-School!"]), " ", _h('p', ["Discover how you can make a difference today."]), " ", _vm._m(3), " ", _h('p', [_h('router-link', {
	    staticClass: "finish-results__return--button",
	    attrs: {
	      "to": {
	        name: 'intro'
	      }
	    }
	  }, ["Return to the quiz"])])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "view"
	  }, [_h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--midground",
	    attrs: {
	      "data-depth": "0.2"
	    }
	  }), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "1"
	    }
	  }, [_h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(80),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  }, [_h('img', {
	    staticClass: "scene__cloud scene__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--second",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--third",
	    attrs: {
	      "src": __webpack_require__(18),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--fourth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__sun",
	    attrs: {
	      "src": __webpack_require__(41),
	      "alt": ""
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "finish-results__message"
	  }, [_h('div', {
	    staticClass: "finish-results__message-wrap"
	  }, [_h('h1', ["Thank you for taking on the Eco-Schools Quiz!"]), " ", _h('p', ["Each question was designed to get you thinking about simple actions that can be taken to help your school become more eco-friendly. No matter what your score, we hope you feel energised and inspired! And remember, you and your school have the power to make changes that will benefit everyone on our planet."])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "finish-results__block finish-results__block--half finish-results__block--share"
	  }, [_h('div', {
	    staticClass: "finish-results__block-wrap"
	  }, [_h('h2', ["Share the quiz"]), " ", _h('ul', {
	    staticClass: "social-media"
	  }, [_h('li', {
	    staticClass: "social-media__item social-media__item--facebook"
	  }, [_h('a', {
	    attrs: {
	      "href": "https://www.facebook.com/share.php",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, ["Facebook"])]), " ", _h('li', {
	    staticClass: "social-media__item social-media__item--twitter"
	  }, [_h('a', {
	    attrs: {
	      "href": "https://twitter.com/intent/tweet",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, ["Twitter"])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('p', [_h('a', {
	    attrs: {
	      "href": "https://members.eco-schools.org.uk/signup",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, ["Register"])])
	}]}

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "classroom"
	    }
	  }, [_h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--pupil",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "18",
	      "data-delay": "3500",
	      "data-interval": "5000"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--teacher",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "18",
	      "data-delay": "1000",
	      "data-interval": "5000"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--foreground",
	    attrs: {
	      "src": __webpack_require__(64),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--midground",
	    attrs: {
	      "data-depth": "0.2"
	    }
	  }, [_h('div', {
	    staticClass: "clock"
	  }, [_h('img', {
	    staticClass: "clock__hand",
	    attrs: {
	      "src": __webpack_require__(155),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "clock__face",
	    attrs: {
	      "src": __webpack_require__(63),
	      "alt": ""
	    }
	  })]), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--midground",
	    attrs: {
	      "src": __webpack_require__(65),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "1"
	    }
	  }, [_h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(62),
	      "alt": ""
	    }
	  }), " ", _h('div', {
	    staticClass: "window__clouds"
	  }, [_h('img', {
	    staticClass: "window__cloud window__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--second",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--third",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  })])]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  })])])
	}]}

/***/ },
/* 219 */,
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "intro"
	    }
	  }, [_h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--schoolboy",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "25",
	      "data-delay": "0",
	      "data-interval": "0"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--cyclist",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "20",
	      "data-delay": "0",
	      "data-interval": "0"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--foreground",
	    attrs: {
	      "src": __webpack_require__(39),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--midground",
	    attrs: {
	      "data-depth": "0.2"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--flag",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "20",
	      "data-delay": "0",
	      "data-interval": "0"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--midground",
	    attrs: {
	      "src": __webpack_require__(40),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "1"
	    }
	  }, [_h('img', {
	    staticClass: "anim anim--turbine",
	    attrs: {
	      "src": __webpack_require__(24),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(38),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  }, [_h('img', {
	    staticClass: "scene__cloud scene__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--second",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--third",
	    attrs: {
	      "src": __webpack_require__(18),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--fourth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__sun",
	    attrs: {
	      "src": __webpack_require__(41),
	      "alt": ""
	    }
	  })])])])
	}]}

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "start"
	    }
	  }, [_vm._m(0), " ", _h('div', {
	    staticClass: "start-message"
	  }, [_h('div', {
	    staticClass: "start-message__frame"
	  }, [_h('div', {
	    staticClass: "start-message__frame-wrap"
	  }, [_h('h1', {
	    staticClass: "start-message__title"
	  }, ["The Eco-Schools’ Quiz"]), " ", _h('p', ["Welcome to The Eco-Schools’ Quiz! Explore the 6 different school areas and answer 30 eco-inspired, multiple-choice questions. Each question shows a great example of how you and your school can make a difference. Whether you’re taking on the quiz single-handedly, or working as a team, we hope you have lots of fun, learn some interesting facts, and leave feeling inspired! Good luck!"]), " ", _h('button', {
	    staticClass: "start-trigger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.goStart
	    }
	  }, [_h('img', {
	    staticClass: "start-trigger__image",
	    attrs: {
	      "src": __webpack_require__(184),
	      "alt": ""
	    }
	  }), " ", _h('span', {
	    staticClass: "start-trigger__text"
	  }, ["Start"])])])])]), " ", _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--midground",
	    attrs: {
	      "data-depth": "0.2"
	    }
	  }), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "1"
	    }
	  }, [_h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(80),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  }, [_h('img', {
	    staticClass: "scene__cloud scene__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--second",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--third",
	    attrs: {
	      "src": __webpack_require__(18),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--fourth",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__sun",
	    attrs: {
	      "src": __webpack_require__(41),
	      "alt": ""
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "start-privacy"
	  }, [_h('a', {
	    staticClass: "start-privacy__link",
	    attrs: {
	      "href": "https://www.eco-schools.org.uk/privacy/",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, ["Privacy Policy"])])
	}]}

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "school-grounds"
	    }
	  }, [_h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--pupil",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "15",
	      "data-delay": "1500",
	      "data-interval": "5000"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--butterflies-left",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "15",
	      "data-delay": "0",
	      "data-interval": "0"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--butterflies-right",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "15",
	      "data-delay": "0",
	      "data-interval": "0"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--foreground",
	    attrs: {
	      "src": __webpack_require__(78),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--midground",
	    attrs: {
	      "data-depth": "0.2"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--birdhouse",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "12",
	      "data-delay": "5000",
	      "data-interval": "5000"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--midground",
	    attrs: {
	      "src": __webpack_require__(79),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "1"
	    }
	  }, [_h('img', {
	    staticClass: "anim anim--turbine",
	    attrs: {
	      "src": __webpack_require__(24),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(77),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  }, [_h('img', {
	    staticClass: "scene__cloud scene__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--second",
	    attrs: {
	      "src": __webpack_require__(18),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__cloud scene__cloud--third",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  })])])])
	}]}

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "canteen"
	    }
	  }, [_h('ul', {
	    staticClass: "scene"
	  }, [_h('li', {
	    staticClass: "layer scene__layer scene__layer--ground",
	    attrs: {
	      "data-depth": "-0.2"
	    }
	  }, [_h('div', {
	    staticClass: "scene__illus scene__illus--ground"
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--foreground",
	    attrs: {
	      "data-depth": "0.0"
	    }
	  }, [_h('div', {
	    staticClass: "sprite sprite--pupil-drinking",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "20",
	      "data-delay": "1000",
	      "data-interval": "8000"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--pupil-plate",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "24",
	      "data-delay": "2500",
	      "data-interval": "4000"
	    }
	  }), " ", _h('div', {
	    staticClass: "sprite sprite--lady",
	    attrs: {
	      "data-frames": "49",
	      "data-framerate": "24",
	      "data-delay": "0",
	      "data-interval": "4000"
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--foreground",
	    attrs: {
	      "src": __webpack_require__(60),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--midground",
	    attrs: {
	      "data-depth": "0.2"
	    }
	  }, [_h('img', {
	    staticClass: "window__frames",
	    attrs: {
	      "src": __webpack_require__(69),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "scene__illus scene__illus--midground",
	    attrs: {
	      "src": __webpack_require__(61),
	      "alt": ""
	    }
	  })]), " ", " ", _h('li', {
	    staticClass: "layer scene__layer scene__layer--background",
	    attrs: {
	      "data-depth": "1"
	    }
	  }, [_h('img', {
	    staticClass: "scene__illus scene__illus--background",
	    attrs: {
	      "src": __webpack_require__(59),
	      "alt": ""
	    }
	  }), " ", _h('div', {
	    staticClass: "window__clouds"
	  }, [_h('img', {
	    staticClass: "window__cloud window__cloud--first",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--second",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  }), " ", _h('img', {
	    staticClass: "window__cloud window__cloud--third",
	    attrs: {
	      "src": __webpack_require__(1),
	      "alt": ""
	    }
	  })])]), " ", " ", _h('li', {
	    staticClass: "scene__sky"
	  })])])
	}]}

/***/ },
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(198);

/***/ }
]);


// WEBPACK FOOTER //
// static/js/0.4f264e31421e39e32712.js